<app-global-toaster *ngIf="globalToasterSerive.getToaster().show" />

<!-- Block 1: When showCalendarEventLoginTitle is true -->
<div
    *ngIf="showCalendarEventLoginTitle"
    class="tw-bg-no-repeat tw-bg-gradient-to-b tw-from-[#e6e6e6] tw-to-[#FFFFFF] tw-bg-[length:100%] tw-relative tw-min-h-[100vh]"
>
    <header>
        <div
            class="tw-relative tw-flex tw-justify-center md:tw-justify-start tw-pt-5 tw-min-h-[5rem] tw-w-full tw-px-[5vw] md:tw-px-[4vw]"
        >
            <div
                class="tw-flex tw-justify-center tw-items-center lg:tw-justify-start sm:tw-justify-center"
            >
                <img
                    ga-event-id="imsme_top_button_lp_click"
                    ga-event-category="Login Page Button"
                    ga-event-label="IMSME Icon Home Button Top"
                    ga-track="track"
                    [routerLink]="['/home']"
                    src="/assets/images/logo/header_desktop.webp"
                    alt="logo"
                    class="tw-cursor-pointer tw-h-auto tw-w-[50%] sm:tw-w-[50%] lg:tw-w-[35%]"
                />
            </div>
        </div>
    </header>

    <div class="sm:tw-flex tw-hidden tw-justify-evenly">
        <div class="tw-flex">
            <div class="tw-flex tw-mb-4">
                <div
                    class="tw-w-1/2 tw-flex tw-justify-center sm:tw-justify-center md:tw-justify-start tw-gap-[6vw] lg:tw-mt-[3rem] tw-px-[20px] lg:tw-px-[8rem] tw-pb-6 md:tw-pb-auto"
                >
                    <div
                        class="tw-flex tw-flex-col lg:tw-items-start tw-mt-10 tw-mx-[1.5rem] lg:tw-mx-[2.5rem] tw-max-w-[700px]"
                    >
                        <button
                            id="hiddenGAButton"
                            ga-event-id="success_register_login_button_ssp_click"
                            ga-event-category="Sign Up Success Page Button"
                            ga-event-label="Success Register Button"
                            ga-track="track"
                            style="visibility: hidden; position: absolute"
                        >
                            Hidden GA Event Button
                        </button>

                        <div
                            class="tw-font-bold tw-text-[18px] sm:tw-text-[18px] md:tw-text-[24px] tw-leading-[18.8px] sm:tw-leading-[18.8px] md:tw-leading-[28.8px] tw-text-[#3C3C3C] tw-w-auto md:tw-w-full"
                        >
                            <div *ngIf="!errorOnEvent">
                                {{ "SIGN_IN_EVENT.TITLE" | translate }}
                            </div>
                            <div *ngIf="errorOnEvent" class="tw-text-[36px]">
                                {{ "SIGN_IN_EVENT.TITLE_ERROR_1" | translate }}
                            </div>
                            <div *ngIf="errorOnEvent" class="tw-text-[36px]">
                                {{ "SIGN_IN_EVENT.TITLE_ERROR_2" | translate }}
                            </div>

                            <div
                                *ngIf="errorOnEvent"
                                class="tw-font-medium tw-text-[20px] tw-mt-[10px]"
                            >
                                <div>
                                    {{
                                        "SIGN_IN_EVENT.SUBTITLE_ERROR"
                                            | translate
                                    }}
                                </div>
                                <ul class="tw-list-disc tw-mx-[25px]">
                                    <li class="tw-mt-[10px]">
                                        {{
                                            "SIGN_IN_EVENT.SUBTITLE_ERROR_1"
                                                | translate
                                        }}
                                        <span
                                            class="tw-underline tw-text-blue-600"
                                            ><a
                                                target="_self"
                                                href="/cgc-developmental-programme"
                                                >{{
                                                    "SIGN_IN_EVENT.EVENT"
                                                        | translate
                                                }}</a
                                            ></span
                                        >
                                        <span
                                            *ngIf="
                                                getLocalStorageValue(
                                                    'language'
                                                ) == 'bm'
                                            "
                                            >{{
                                                "SIGN_IN_EVENT.SUBTITLE_ERROR_1_1"
                                                    | translate
                                            }}</span
                                        >
                                    </li>
                                    <li class="tw-mt-[10px]">
                                        {{
                                            "SIGN_IN_EVENT.SUBTITLE_ERROR_2"
                                                | translate
                                        }}
                                        <span
                                            class="tw-underline tw-text-blue-600"
                                            ><a target="_self" href="/home">{{
                                                "SIGN_IN_EVENT.HOME" | translate
                                            }}</a></span
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="tw-w-full tw-mt-8">
                            <ng-container
                                *ngTemplateOutlet="
                                    signInFormTemplate;
                                    context: {
                                        form: signInForm,
                                        submitted: submitted
                                    }
                                "
                            ></ng-container>
                        </div>
                    </div>
                </div>
                <div
                    class="tw-w-1/2 tw-flex tw-flex-col tw-items-center tw-px-[20px]"
                >
                    <div
                        class="tw-rounded-[40px]"
                        [ngClass]="!errorOnEvent ? 'tw-bg-[#0A4495]' : null"
                    >
                        <img
                            *ngIf="!errorOnEvent"
                            src="assets/images/event-login-bg.png"
                            alt="Login-bg"
                            class="tw-min-w-[95%] tw-m-auto"
                        />
                        <img
                            *ngIf="errorOnEvent"
                            src="assets/images/lnd-signin.png"
                            alt="sign-in"
                            class="tw-w-[90%] tw-m-auto"
                        />
                        <div
                            *ngIf="!errorOnEvent"
                            class="tw-flex tw-flex-col tw-gap-[10px] tw-my-[40px] tw-mx-[15%]"
                        >
                            <div
                                class="tw-text-[14px] tw-text-white tw-uppercase"
                            >
                                {{ "SIGN_IN_EVENT.EVENT_DETAILS" | translate }}
                            </div>
                            <div
                                class="tw-text-[24px] tw-font-bold tw-text-white"
                            >
                                {{ eventData?.title }}
                            </div>
                            <div
                                class="tw-text-[16px] tw-font-medium tw-text-white tw-mt-[30px]"
                            >
                                {{ "SIGN_IN_EVENT.DATE" | translate }}
                                {{ dateOfEvent }}
                            </div>
                            <div
                                class="tw-text-[16px] tw-font-medium tw-text-white"
                            >
                                {{ "SIGN_IN_EVENT.DAY" | translate }}
                                {{ dayOfEvent }}, {{ eventStartTime }} -
                                {{ eventEndTime }}
                            </div>
                            <div
                                class="tw-text-[16px] tw-font-medium tw-text-white"
                            >
                                {{ "SIGN_IN_EVENT.VENUE" | translate }}
                                {{ eventData?.venue }}
                            </div>
                            <div
                                class="tw-text-[16px] tw-font-semibold tw-text-white tw-mt-[30px]"
                            >
                                {{ "SIGN_IN_EVENT.ABOUT_EVENT" | translate }}
                            </div>
                            <ul
                                class="tw-list-disc tw-mx-[15px] tw-text-white"
                                *ngIf="eventData?.eventDescription"
                            >
                                <li>{{ eventData?.eventDescription }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        class="tw-flex sm:tw-hidden tw-justify-center sm:tw-justify-center md:tw-justify-start tw-gap-[6vw] md:tw-mt-[3rem] md:tw-px-[8rem] tw-pb-6 md:tw-pb-auto"
    >
        <div
            class="tw-flex tw-flex-col sm:tw-items-start tw-mt-5 tw-mx-[1.5rem] lg:tw-mx-[2.5rem] tw-max-w-[700px]"
        >
            <div class="tw-flex tw-flex-col tw-items-start tw-mb-[30px]">
                <div
                    class="tw-rounded-[20px]"
                    [ngClass]="!errorOnEvent ? 'tw-bg-[#0A4495]' : null"
                >
                    <img
                        *ngIf="!errorOnEvent"
                        src="assets/images/event-login-bg.png"
                        alt="Login-bg"
                        class="tw-w-full tw-m-auto"
                    />
                    <img
                        *ngIf="errorOnEvent"
                        src="assets/images/lnd-signin.png"
                        alt="Sign-in"
                        class="tw-w-[100%] tw-m-auto"
                    />
                    <div
                        *ngIf="!errorOnEvent"
                        class="tw-flex tw-flex-col tw-gap-[10px] tw-my-[40px] tw-mx-[15%]"
                    >
                        <div class="tw-text-[13px] tw-text-white tw-uppercase">
                            {{ "SIGN_IN_EVENT.EVENT_DETAILS" | translate }}
                        </div>
                        <div class="tw-text-[22px] tw-font-bold tw-text-white">
                            {{ eventData?.title }}
                        </div>
                        <div
                            class="tw-text-[14px] tw-font-medium tw-text-white tw-mt-[30px]"
                        >
                            {{ "SIGN_IN_EVENT.DATE" | translate }}
                            {{ dateOfEvent }}
                        </div>
                        <div
                            class="tw-text-[14px] tw-font-medium tw-text-white"
                        >
                            {{ "SIGN_IN_EVENT.DAY" | translate }}
                            {{ dayOfEvent }}, {{ eventStartTime }} -
                            {{ eventEndTime }}
                        </div>
                        <div
                            class="tw-text-[14px] tw-font-medium tw-text-white"
                        >
                            {{ "SIGN_IN_EVENT.VENUE" | translate }}
                            {{ eventData?.venue }}
                        </div>
                        <div
                            class="tw-text-[14px] tw-font-semibold tw-text-white tw-mt-[30px]"
                        >
                            {{ "SIGN_IN_EVENT.ABOUT_EVENT" | translate }}
                        </div>
                        <ul
                            class="tw-list-disc tw-mx-[13px] tw-text-white"
                            *ngIf="eventData?.eventDescription"
                        >
                            <li>{{ eventData?.eventDescription }}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div
                class="tw-font-bold tw-text-[18px] sm:tw-text-[18px] md:tw-text-[24px] tw-leading-[18.8px] sm:tw-leading-[18.8px] md:tw-leading-[28.8px] tw-text-[#3C3C3C] tw-w-auto md:tw-w-[304px]"
            >
                <div *ngIf="!errorOnEvent">
                    {{ "SIGN_IN_EVENT.TITLE" | translate }}
                </div>
                <div *ngIf="errorOnEvent">
                    {{ "SIGN_IN_EVENT.TITLE_ERROR_1" | translate }}
                </div>
                <div *ngIf="errorOnEvent">
                    {{ "SIGN_IN_EVENT.TITLE_ERROR_2" | translate }}
                </div>

                <div
                    *ngIf="errorOnEvent"
                    class="tw-font-medium tw-text-[20px] tw-mt-[10px]"
                >
                    <div>{{ "SIGN_IN_EVENT.SUBTITLE_ERROR" | translate }}</div>
                    <ul class="tw-list-disc tw-mx-[25px]">
                        <li class="tw-mt-[10px]">
                            {{ "SIGN_IN_EVENT.SUBTITLE_ERROR_1" | translate }}
                            <span class="tw-underline tw-text-blue-600"
                                ><a
                                    target="_self"
                                    href="/cgc-developmental-programme"
                                    >{{ "SIGN_IN_EVENT.EVENT" | translate }}</a
                                ></span
                            >
                            <span
                                *ngIf="getLocalStorageValue('language') == 'bm'"
                                >{{
                                    "SIGN_IN_EVENT.SUBTITLE_ERROR_1_1"
                                        | translate
                                }}</span
                            >
                        </li>
                        <li class="tw-mt-[10px]">
                            {{ "SIGN_IN_EVENT.SUBTITLE_ERROR_2" | translate }}
                            <span class="tw-underline tw-text-blue-600"
                                ><a target="_self" href="/home">{{
                                    "SIGN_IN_EVENT.HOME" | translate
                                }}</a></span
                            >
                        </li>
                    </ul>
                </div>
            </div>

            <div class="tw-mt-8">
                <ng-container
                    *ngTemplateOutlet="
                        signInFormTemplate;
                        context: { form: signInForm, submitted: submitted }
                    "
                ></ng-container>
            </div>
        </div>
    </div>
</div>

<!-- Block 2: When showCalendarEventLoginTitle is false -->
<div
    *ngIf="!showCalendarEventLoginTitle"
    class="tw-flex tw-justify-evenly sm:tw-p-6 tw-h-[100vh] tw-gap-5 sm:tw-bg-[#0A0A75] tw-bg-transparent tw-items-start sm:tw-items-center"
>
    <div
        class="tw-w-full lg:tw-w-[60%] tw-pt-4 tw-pb-10 xl:tw-w-[40%] tw-bg-white tw-rounded-[24px] tw-flex tw-flex-col tw-relative tw-z-[2]"
    >
        <header class="tw-text-center">
            <div
                class="tw-flex tw-justify-between tw-items-center tw-min-h-[4rem] tw-px-8 md:tw-px-10"
            >
                <div class="tw-flex-1"></div>
                <img
                    ga-event-id="imsme_top_button_lp_click"
                    ga-event-category="Login Page Button"
                    ga-event-label="IMSME Icon Home Button Top"
                    ga-track="track"
                    [routerLink]="['/home']"
                    src="/assets/images/logo/header_desktop.webp"
                    alt="IMSME Logo"
                    class="tw-cursor-pointer tw-h-auto tw-w-[35%] tw-mx-auto"
                />
                <div
                    class="tw-text-[16px] tw-font-medium tw-flex-1 tw-text-right"
                >
                    <span
                        class="tw-cursor-pointer"
                        (click)="switchLanguage('en')"
                    >
                        {{ "LANG.EN" | translate }}
                    </span>
                    |
                    <span
                        class="tw-cursor-pointer"
                        (click)="switchLanguage('bm')"
                    >
                        {{ "LANG.BM" | translate }}
                    </span>
                </div>
            </div>
        </header>

        <div class="tw-px-8 md:tw-px-16">
            <div
                class="tw-text-[24px] md:tw-text-[28px] tw-font-semibold tw-w-full"
            >
                {{ "COMMON.LOGIN" | translate }}
            </div>
        </div>

        <div class="tw-px-8 md:tw-px-16 tw-mt-4">
            <ng-container
                *ngTemplateOutlet="
                    signInFormTemplate;
                    context: { form: signInForm, submitted: submitted }
                "
            ></ng-container>
        </div>
    </div>
    <img
        class="tw-hidden sm:tw-block tw-absolute tw-left-0 tw-bottom-0"
        src="../../../../assets/images/login-signup/Blue-1.png"
        alt="Blue Img"
    />
</div>

<ng-template
    #signInFormTemplate
    let-signInForm="form"
    let-submitted="submitted"
>
    <form
        *ngIf="!errorOnEvent"
        [formGroup]="signInForm"
        (ngSubmit)="onSignIn()"
        class="tw-flex tw-flex-col tw-gap-6 tw-w-full"
    >
        <input-general
            class="tw-block tw-w-[100%]"
            [mandatoryField]="true"
            [label]="'FORM.USERID_EMAIL' | translate"
            [placeHolder]="'Mohd_Abu'"
            [controlName]="'username'"
            [errors]="getErrors('username', 'FORM.USERID_EMAIL' | translate)"
        ></input-general>

        <input-general
            class="tw-block tw-w-[100%]"
            [mandatoryField]="true"
            [label]="'COMMON.PASSWORD' | translate"
            [placeHolder]="'**********'"
            [hideInput]="true"
            [controlName]="'password'"
            [errors]="getErrors('password', 'COMMON.PASSWORD' | translate)"
        ></input-general>

        <div class="g-recaptcha">
            <re-captcha
                #recaptchaRef
                class="tw-flex tw-justify-center !tw-w-full"
                formControlName="recaptcha"
                [siteKey]="siteKey"
                (resolved)="onCheckCaptcha($event)"
            ></re-captcha>
        </div>

        <button
            ga-event-id="login_button_lp_click"
            ga-event-category="Login Page Button"
            [attr.ga-event-label]="
                JSON.stringify({
                    label: 'Login Button Click',
                    username: signInForm.value.username
                })
            "
            ga-track="track"
            [disabled]="submitted && signInForm.valid"
            class="tw-rounded-[32px] tw-text-white tw-font-bold tw-h-[56px] tw-w-full tw-text-[16px]"
            [ngClass]="
                signInForm.invalid || submitted
                    ? 'tw-bg-[#FFA53C] tw-opacity-50'
                    : 'tw-bg-[#FFA53C]'
            "
            type="submit"
        >
            {{ "COMMON.LOGIN" | translate }}
        </button>

        <div class="tw-flex tw-justify-between tw-gap-2 tw-text-[#7B7575]">
            <div
                class="tw-underline access-btn"
                ga-event-id="forgot_password_lp_click"
                ga-event-category="Login Page Button"
                ga-event-label="Forgot Password Button Click"
                ga-track="track"
                (click)="onForgotPassword()"
            >
                {{ "LOGIN.FORGOT_PASSWORD" | translate }}
            </div>
            <div
                class="tw-underline"
                style="cursor: pointer"
                ga-event-id="register_lp_click"
                ga-event-category="Login Page Button"
                ga-event-label="Regiter Button Click"
                ga-track="track"
                (click)="onSignUp()"
            >
                {{ "COMMON.SIGNUP" | translate }}
            </div>
        </div>
    </form>
</ng-template>
